<template>
    <div id="AssetFeatureList">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Asset Standard Feature List</div>
                    <div class="btn-groups text-right">
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                            <i class="fp-export"></i> Export
                        </a>
                        <router-link v-if="canAdd == true" class="btn btn-primary" v-bind:to="{name: 'AssetFeatureCreate'}" > <i class="fp-add"> </i> Add</router-link>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content standard-feature-lists">
                        <!-- <div class="FiltersLabel">Filters</div> -->
                        <data-table-filter-config :moduleName="'listAssetFeature'" ref="filterComponent" @cancelSelection="cancelAll"></data-table-filter-config>
                        <section class="bg-white data-table">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'listAssetFeature'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listAssetFeatureTable"
                                    mode="remote"
                                    title="AssetFeature"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    @on-select-all="onSelectAll"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: asset_feature_value,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'" class='text-center'>
                                                <router-link title="Edit Feature" v-if="canUpdate" class="fp-edit" v-bind:to="{name: 'AssetFeatureEdit',params:{id:props.row.id}}"></router-link>
                                            </div>
                                            <div v-if="props.column.field == 'asset_unit_no'" class='text-center'>
                                                <router-link title="View Asset" class="color-blue" v-bind:key="'action_view' + key" v-bind:to="{name: 'AssetView',params:{id:props.row.asset_id},query:{from:'feature'}}">{{props.row.asset_unit_no}}</router-link>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>

                                    <div slot="selected-row-actions">
                                        <button v-if="asset_feature_value  == true" id="deleteAssetFeatureBtn" v-on:click.prevent="assetFeatureDelete" class="btn btn-primary">Delete</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import EventBus from "./event-bus";
import Vue from "vue";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "AssetFeatureList",
        metaInfo: {
            // title will be injected into parent titleTemplate
            title: "Asset Standard Feature List | " +process.env.COPYRIGHT_NAME
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                 {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                },
                {
                    label: 'Unit No.',
                    field: 'asset_unit_no',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Unit No.", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Feature Category',
                    field: 'asset_feature_category',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Feature Category", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Code',
                    field: 'code',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Name',
                    field: 'name',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Weight Front',
                    field: 'weight_front',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Weight Front", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Weight Rear',
                    field: 'weight_rear',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Weight Rear", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Created By',
                    field: 'created_by',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Created By", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Created At',
                    field: 'created_at',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            asset_feature_value: false,
            loading:false,
            action:'list',
            canAdd:false,
            canUpdate:false,
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_asset_feature') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'delete_asset_feature') {
                            self.asset_feature_value = true;
                        }
                        if (permissions[i].name == 'add_asset_feature') {
                            self.canAdd = true;
                            self.canUpdate = true;
                        }

                    }
                }

            }

        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            //self.loadList();
            self.getPermissions();
            self.serverParams.sort = { field: "asset_unit_no",type:"desc"};
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listAssetFeatureTable.unselectAllInternal();
            },
            /*updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },

            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadList();
            },

            onPerPageChange(params) {
                this.serverParams.page=1;
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                this.loadList();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                {
                    field:('name');
                    field:('code');
                    field:('weight_front');
                    field:('weight_rear');
                    field:('asset_unit_no')
                    field:('asset_feature_category');
                    field:('created_at');
                    field:('created_by');
                };
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;
                if (this.firstLoad == 1 || filters.name ||  filters.code || filters.weight_front || filters.weight_rear || filters.asset_unit_no ||filters.asset_feature_category || filters.created_at || filters.created_by) {
                    this.loadList();
                }
            },*/
            exportReports: function() {
                var self = this;
                this.action = "export";
                this.loadList();
            },
            selectionChanged(param) {
                var self = this;
                self.serverParams.selectedAll = false;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                return;
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

            /*onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadList();
            },*/

            loadList() {
                var self = this;
                var data = this.$refs['listAssetFeatureTable'].selectedRows;
                var selectedRows = [];

                for (var i = 0; i < data.length; i++) {
                    selectedRows.push(self.$refs['listAssetFeatureTable'].selectedRows[i].id)
                }
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    all:self.serverParams.selectedAll,
                    selectedRows:selectedRows,
                    action:self.action,
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/assetfeature/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            if ( self.action == "export" ) {

                                self.action = "list";
                                if ( data.code == "201" ) {
                                    alert(data.message);
                                } else {

                                    self.excel = data.content.web;
                                    var save = document.createElement("a");
                                    save.href = self.excel;
                                    save.download = data.content.web;
                                    save.target = "_blank";

                                    document.body.appendChild(save);
                                    save.click();
                                    document.body.removeChild(save);

                                }
                                    self.loadList();
                            }else if ( self.action == "delete" ) {

                                self.action = "list";
                                $("#deleteAssetFeatureBtn").val("Delete");

                                self.$refs.filterComponent.clearSelectAll();
                                self.loadList();
                                EventBus.$emit('clear-all-flags', false);   //hide alert of selection

                            }else{
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.filteredFlag = false;
                            }
                        }else{
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.filteredFlag = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if ( self.action == "delete" ) {
                            self.generateStatusCodeMessage(jqXHR, true, 'asset-std-feature-delete')
                        }else{
                            self.generateStatusCodeMessage(jqXHR, false, 'asset-std-feature-laod-list')
                        }
                    }
                });
            },

            assetFeatureDelete() {
                if (confirm('Are you sure that you want to delete this Asset Feature ? ')) {
                    this.action = "delete";
                    $("#deleteAssetFeatureBtn").val("Deleting ...");

                    this.loadList();
                }
                /*var data = this.$refs['listAssetFeatureTable'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listAssetFeatureTable'].selectedRows[i].id)
                }

                if (confirm('Are you sure that you want to delete this Asset Feature ? ')) {
                    self.loading = true;
                    $("#deleteAssetFeatureBtn").val("Deleting ...");
                    $.ajax({
                        url: process.env.ROOT_API + "/assetfeature/delete",
                        type: "POST",
                        data: 'id=' + use,
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;
                            setTimeout(function () {
                            $(".alert-success").removeClass("show");
                                $(".alert-success").addClass("hide");
                            }, 10000);
                            setTimeout(function () {
                                $("#deleteAssetFeatureBtn").val("Delete");
                            }, 10000);
                            if (data.code == 200) {
                                self.loadList();
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            if (jqXHR.status == 0) {
                                self.error = "Remote server cannot be reached";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem('user_obj');
                                    localStorage.removeItem('tkn');

                                    self.$router.push("/");
                                }
                               self.error = jqXHR.responseJSON.message;
                            }
                        }
                    });
                }*/
            }
        }
    };
</script>

<style scope>
</style>



// WEBPACK FOOTER //
// src/components/AssetFeatureList.vue